@if (offline && showIndividualLocks) {
    @for (option of optionsOrFallback; track option) {
        <div class="offline-multiple-lock">
            <vn-icon size="16" name="theme-lock" [style.color]="textColor" />
        </div>
    }
} @else {
    <ng-container *msShowInEpcot="false">
        @if (offline) {
            <span class="theme-locked-i" [style.color]="textColor"></span>
        } @else {
            @if (optionGroup.balanced && optionGroup.categoryAttribute) {
                <div class="six-pack-option option-group-attribute">
                    <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="optionGroup.categoryAttribute" />
                </div>
            }
            @for (option of options; track trackOption($index, option)) {
                <ms-six-pack-option
                    [decorateAttribute]="decorateAttribute"
                    [option]="option"
                    [optionGroup]="optionGroup"
                    [event]="event"
                    [isHighlighted]="shouldHighlight(option)"
                    [trackingPosition]="trackingPosition"
                    [isAutomatedMarquee]="isAutomatedMarquee"
                    [msAutomation]="getAutomationAttributes(option, optionGroup)"
                    [showThemeLockIcon]="showIndividualLocks" />
            }
        }
    </ng-container>
    <ng-container *msShowInEpcot="true">
        @if (offline) {
            <span class="theme-lock" [style.color]="textColor"></span>
        } @else {
            @if (optionGroup.balanced && optionGroup.categoryAttribute) {
                <div class="six-pack-option option-group-attribute">
                    <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="optionGroup.categoryAttribute" />
                </div>
            }
            @for (option of options; track trackOption($index, option)) {
                <ms-six-pack-option
                    [decorateAttribute]="decorateAttribute"
                    [option]="option"
                    [optionGroup]="optionGroup"
                    [event]="event"
                    [isHighlighted]="shouldHighlight(option)"
                    [trackingPosition]="trackingPosition"
                    [isAutomatedMarquee]="isAutomatedMarquee"
                    [msAutomation]="getAutomationAttributes(option, optionGroup)"
                    [showThemeLockIcon]="showIndividualLocks" />
            }
        }
    </ng-container>
}
